module.exports = __webpack_public_path__ + "img/中国总公司： 营口博爱医药连锁有限公司：http：／／www.boaiyiyao.com  日本分公司： 株式会社政轩：htt.dcc2db38.png";